import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { EmotionalBlock } from './components/EmotionalBlock';
import { ProductIntro } from './components/ProductIntro';
import { Benefits } from './components/Benefits';
import { Activities } from './components/Activities';
import { Differentiator } from './components/Differentiator';
import { BonusSection } from './components/BonusSection';
import { BonusValue } from './components/BonusValue';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalOffer } from './components/FinalOffer';
import { Closing } from './components/Closing';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen bg-gray-50 font-inter selection:bg-brand-yellow selection:text-brand-black" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainPoints data-id="element-4" />
        <EmotionalBlock data-id="element-5" />
        <ProductIntro data-id="element-6" />
        <Benefits data-id="element-7" />
        <Activities data-id="element-8" />
        <Differentiator data-id="element-9" />
        <BonusSection data-id="element-10" />
        <BonusValue data-id="element-11" />
        <Testimonials data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalOffer data-id="element-14" />
      </main>

      <Closing data-id="element-15" />
      <PurchasePopup data-id="element-16" />

      {/* Sticky Mobile CTA */}
      <div className="sm:hidden fixed bottom-0 left-0 right-0 p-3 bg-white/90 backdrop-blur-sm border-t border-gray-200 z-40 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]" data-id="element-17">
        <a href="https://impulsodigital.vip/cart/44763616936022:1" className="block w-full bg-brand-green text-white text-center py-3 rounded-xl font-archivo text-xl uppercase shadow-lg active:scale-95 transition-transform" data-id="element-18">
          🌱 QUIERO EL KIT
        </a>
      </div>
    </div>;
}